import { AssetType } from "src/app/_models/AssetType";
import { DialogTemplate, MitFieldInfo } from "src/app/_models/body";
import { InputFieldType } from "src/app/common/constants";

export const AssetAbilityTemplate = (abilityList: Array<any>): DialogTemplate => {
    return {
        dialogTitle: 'Update Assets Abilities',
        dialogFields: [
            {
                key: 'abilityIds',
                label: 'Asset Ability',
                type: InputFieldType.Selector,
                size: 24,
                mode: 'multiple',
                options: abilityList
            },
        ]
    }
}

export const ImageTypeTemplate = (source: any, isBatch: boolean): Array<MitFieldInfo> => {
    return [
        {
            key: 'assetType',
            label: 'Asset Type',
            type: InputFieldType.Selector,
            size: 12,
            options: source?.assetTypeSelections,
            required: true
        },
        {
            key: 'categoryId',
            label: 'Category Name',
            type: InputFieldType.Selector,
            size: 12,
            options: source?.categoryFilterByType[AssetType.Image],
            required: true
        },
        {
            key: 'scaleInMap',
            label: 'Scale In Map',
            type: InputFieldType.Number,
            size: 12,
            required: true
        },
        {
            key: 'name',
            label: 'Name',
            type: InputFieldType.Text,
            size: 12,
            required: true
        },
        {
            key: 'description',
            label: 'Description',
            type: InputFieldType.Text,
            size: 12,
        },
        {
            key: 'numberOfTokensUnlocked',
            label: 'Number Of Tokens Unlocked',
            type: InputFieldType.Number,
            size: 12,
            required: true
        },
        {
            key: 'adUrlLinked',
            label: 'Ad Url Linked',
            type: InputFieldType.Text,
            size: 12,
        },
        {
            key: 'assetStatus',
            label: 'Asset Status',
            type: InputFieldType.Selector,
            size: 12,
            options: ['Active', 'Inactive'],
            required: true,
            isClearDisabled: true
        },
        {
            key: 'businessType',
            label: 'Business Type',
            type: InputFieldType.Selector,
            size: 12,
            options: source?.assetBusinessTypeSelections,
            required: true,
            isClearDisabled: true
        },
        {
            key: 'virtualMallId',
            label: 'Virtual Mall Id',
            type: InputFieldType.Selector,
            size: 12,
            options: source.virtualMall,
            isClearDisabled: true,
            selectorLabel: 'description',
            required: true,
        },
        {
            key: 'tags',
            label: 'Tags',
            type: InputFieldType.Tag,
            size: 24,
        },
        {
            key: 'url',
            label: 'Image File',
            type: InputFieldType.Uploader,
            size: 12,
            required: true,
            showPreviewImage: true,
            accept: isBatch ? 'image/png, image/jpeg' : 'image/*',
            mode: isBatch ? 'multiple' : 'default'
        },
    ]
}

export const VideoTypeTemplate = (source: any, isBatch: boolean): Array<MitFieldInfo> => {
    return [
        {
            key: 'assetType',
            label: 'Asset Type',
            type: InputFieldType.Selector,
            size: 12,
            options: source?.assetTypeSelections,
            required: true
        },
        {
            key: 'categoryId',
            label: 'Category Name',
            type: InputFieldType.Selector,
            size: 12,
            options: source?.categoryFilterByType[AssetType.Video],
            required: true
        },
        {
            key: 'scaleInMap',
            label: 'Scale In Map',
            type: InputFieldType.Number,
            size: 12,
            required: true
        },
        {
            key: 'name',
            label: 'Name',
            type: InputFieldType.Text,
            size: 12,
            required: true
        },
        {
            key: 'description',
            label: 'Description',
            type: InputFieldType.Text,
            size: 12,
        },
        {
            key: 'numberOfTokensUnlocked',
            label: 'Number Of Tokens Unlocked',
            type: InputFieldType.Number,
            size: 12,
            required: true
        },
        {
            key: 'adUrlLinked',
            label: 'Ad Url Linked',
            type: InputFieldType.Text,
            size: 12,
        },
        {
            key: 'assetStatus',
            label: 'Asset Status',
            type: InputFieldType.Selector,
            size: 12,
            options: ['Active', 'Inactive'],
            required: true,
            isClearDisabled: true
        },
        {
            key: 'businessType',
            label: 'Business Type',
            type: InputFieldType.Selector,
            size: 12,
            options: source?.assetBusinessTypeSelections,
            required: true,
            isClearDisabled: true
        },
        {
            key: 'virtualMallId',
            label: 'Virtual Mall Id',
            type: InputFieldType.Selector,
            size: 12,
            options: source.virtualMall,
            isClearDisabled: true,
            selectorLabel: 'description',
            required: true,
        },
        {
            key: 'tags',
            label: 'Tags',
            type: InputFieldType.Tag,
            size: 24,
        },
        {
            key: 'url',
            label: `Video File ${isBatch ? '(files will be matched in order)' : ''}`,
            type: InputFieldType.Uploader,
            size: 12,
            required: true,
            accept: 'video/*',
            mode: isBatch ? 'multiple' : 'default'
        },
        {
            key: 'thumbnailUrl',
            label: `Thumbnail File ${isBatch ? '(files will be matched in order)' : ''}`,
            type: InputFieldType.Uploader,
            size: 12,
            required: true,
            showPreviewImage: true,
            accept: 'image/png, image/jpeg',
            mode: isBatch ? 'multiple' : 'default'
        },
    ]
}

export const Model3dTypeTemplate = (source: any, isBatch: boolean, requiredVisionOS: boolean, getAbilitiesVoiceControllable: () => boolean): Array<MitFieldInfo> => {
    return [
        {
            key: 'assetType',
            label: 'Asset Type',
            type: InputFieldType.Selector,
            size: 12,
            options: source?.assetTypeSelections,
            required: true
        },
        {
            key: 'categoryId',
            label: 'Category Name',
            type: InputFieldType.Selector,
            size: 12,
            options: source?.categoryFilterByType[AssetType.Model3d],
            required: true
        },
        {
            key: 'scaleInMap',
            label: 'Scale In Map',
            type: InputFieldType.Number,
            size: 12,
            required: true
        },
        {
            key: 'abilitiesVoiceControllable',
            label: `Abilities Voice Controllable`,
            type: InputFieldType.Switch,
            size: 12,
        },
        {
            key: 'abilitiyIds',
            label: 'Asset Ability',
            type: InputFieldType.Selector,
            size: 24,
            options: source?.abilityList,
            mode: 'multiple',
            required: getAbilitiesVoiceControllable()
        },

        {
            key: 'name',
            label: 'Name',
            type: InputFieldType.Text,
            size: 12,
            required: true
        },
        {
            key: 'description',
            label: 'Description',
            type: InputFieldType.Text,
            size: 12,
        },
        {
            key: 'numberOfTokensUnlocked',
            label: 'Number Of Tokens Unlocked',
            type: InputFieldType.Number,
            size: 12,
            required: true
        },
        {
            key: 'adUrlLinked',
            label: 'Ad Url Linked',
            type: InputFieldType.Text,
            size: 12,
        },
        {
            key: 'assetStatus',
            label: 'Asset Status',
            type: InputFieldType.Selector,
            size: 12,
            options: ['Active', 'Inactive'],
            required: true,
            isClearDisabled: true
        },
        {
            key: 'businessType',
            label: 'Business Type',
            type: InputFieldType.Selector,
            size: 12,
            options: source?.assetBusinessTypeSelections,
            required: true,
            isClearDisabled: true
        },
        {
            key: 'virtualMallId',
            label: 'Virtual Mall Id',
            type: InputFieldType.Selector,
            size: 12,
            options: source.virtualMall,
            isClearDisabled: true,
            selectorLabel: 'description',
            required: true,
        },
        {
            key: 'tags',
            label: 'Tags',
            type: InputFieldType.Tag,
            size: 24,
        },
        {
            key: 'thumbnailUrl',
            label: `Thumbnail File ${isBatch ? '(files will be matched in order)' : ''}`,
            type: InputFieldType.Uploader,
            size: 12,
            required: true,
            showPreviewImage: true,
            accept: 'image/png, image/jpeg',
            mode: isBatch ? 'multiple' : 'default'

        },
        {
            key: 'url',
            label: `IOS File ${isBatch ? '(files will be matched in order)' : ''}`,
            type: InputFieldType.Uploader,
            size: 12,
            required: true,
            mode: isBatch ? 'multiple' : 'default'
        },
        {
            key: 'androidUrl',
            label: `Android File ${isBatch ? '(files will be matched in order)' : ''}`,
            type: InputFieldType.Uploader,
            size: 12,
            mode: isBatch ? 'multiple' : 'default'
        },
        {
            key: 'visionOSUrl',
            label: `VisionOS File ${isBatch ? '(files will be matched in order)' : ''}`,
            type: InputFieldType.Uploader,
            size: 12,
            mode: isBatch ? 'multiple' : 'default',
            required: requiredVisionOS
        },
        {
            key: 'macOSUrl',
            label: `MacOS File ${isBatch ? '(files will be matched in order)' : ''}`,
            type: InputFieldType.Uploader,
            size: 12,
            mode: isBatch ? 'multiple' : 'default'
        },
        {
            key: 'miniUrl',
            label: `Mini File ${isBatch ? '(files will be matched in order)' : ''}`,
            type: InputFieldType.Uploader,
            size: 12,
            mode: isBatch ? 'multiple' : 'default'
        },
        {
            key: 'androidMiniUrl',
            label: `Android Mini File ${isBatch ? '(files will be matched in order)' : ''}`,
            type: InputFieldType.Uploader,
            size: 12,
            mode: isBatch ? 'multiple' : 'default'
        },
    ]
}

export const AiBuddyChatRoleDescriptionTemplate = (): Array<MitFieldInfo> => {
    return [
        {
            key: 'aiBuddyChatRoleDescription',
            label: `AI Buddy Chat Role Description`,
            type : InputFieldType.Text,
            size: 24,
        },
    ]
}

export const AiBuddyTemplate = (assetAiBuddyVoiceType: Array<any>, speakerProfile: Array<any>): Array<MitFieldInfo> => {
    return [
        {
            key: 'aiBuddyVoiceType',
            label: 'AI Buddy Voice Type',
            type: InputFieldType.Selector,
            size: 12,
            options: assetAiBuddyVoiceType,
            isClearDisabled: true
        },
        {
            key: 'aiBuddyPersonalVoiceSpeakerProfileId',
            label: `AI Buddy Personal Voice Speaker Profile ID`,
            type: InputFieldType.Selector,
            size: 12,
            options: speakerProfile,
        },
        {
            key: 'aiBuddyVoiceRolesUS',
            label: `Ai Buddy Voice Role(en-US) <a href="https://speech.microsoft.com/portal/voicegallery" target="_blank">Voice Library</a>`,
            type: InputFieldType.Text,
            size: 12,
        },
        {
            key: 'aiBuddyVoiceRolesCN',
            label: `Ai Buddy Voice Role(zh-CN) <a href="https://learn.microsoft.com/en-us/azure/ai-services/speech-service/language-support?tabs=tts#prebuilt-neural-voices" target="_blank">Language Support</a>`,
            type: InputFieldType.Text,
            size: 12,
        },
        {
            key: 'aiBuddyVoiceRolesHK',
            label: `Ai Buddy Voice Role(zh-HK)`,
            type: InputFieldType.Text,
            size: 12,
        },
        {
            key: 'aiBuddyVoiceRolesES',
            label: `Ai Buddy Voice Role(es-ES)`,
            type: InputFieldType.Text,
            size: 12,
        },
    ]
}

export const LiveAvatarTemplate = (): Array<MitFieldInfo> => {
    return [
        {
            key: 'liveAvatarProvider',
            label: 'Live Avatar Provider',
            type: InputFieldType.Text,
            size: 12,
            required: true,
        },
        {
            key: 'liveAvatarAvatarId',
            label: 'Live Avatar ID',
            type: InputFieldType.Text,
            size: 12,
            required: true,
        },
        {
            key: 'liveAvatarContextId',
            label: 'Live Avatar Context ID',
            type: InputFieldType.Text,
            size: 12,
            required: true,
        },
        {
            key: 'liveAvatarVoiceId',
            label: 'Live Avatar Voice ID',
            type: InputFieldType.Text,
            size: 12,
            required: true,
        },
        {
            key: 'liveAvatarLanguage',
            label: 'Live Avatar Language',
            type: InputFieldType.Text,
            size: 12,
            required: true,
        },
        {
            key: 'liveAvatarIsSandbox',
            label: 'Live Avatar Is Sandbox',
            type: InputFieldType.Switch,
            size: 12,
        },
        {
            key: 'liveAvatarMaxSessionDuration',
            label: 'Live Avatar Max Session Duration (s)',
            type: InputFieldType.Number,
            size: 12,
            required: true,
        },
        {
            key: 'liveAvatarIdleVideo',
            label: 'Live Avatar Idle Video',
            type: InputFieldType.Uploader,
            size: 12,
            accept: 'video/*',
        },
    ]
}

